import cx from "classnames";
import Image from "next/image";

import { useSettings } from "shared/SettingsProvider/useSettings";
import { useI18n } from "utils/with-i18n.utils";

export const BannerNav = () => {
  const { isBlackFriday } = useSettings();
  const i18n = useI18n();

  return (
    <div
      className={cx(
        "flex items-center text-center min-h-[2rem] max-w-full text-xs lg:text-sm border-b-[1px] lg:border-b-0 overflow-hidden",
        isBlackFriday
          ? "bg-gradient-to-r from-neutral-900 to-[#060607] border-y-white h-14"
          : "bg-yellow border-y-black",
      )}
    >
      {isBlackFriday && (
        <div className="hidden relative flex-none lg:block">
          <Image
            src="/images/black-friday/black-month-banner.webp"
            alt="black friday"
            width={367}
            height={467}
            className="object-contain"
          />
        </div>
      )}

      {/* DESKTOP */}
      <div
        className={cx(
          "hidden lg:block",
          isBlackFriday && "ml-[-357px] grow py-6",
        )}
      >
        {i18n.t(
          isBlackFriday ? "banner.blackFridayContent" : "banner.content",
          {},
          { html: true },
        )}
      </div>

      {/* MOBILE */}
      <div
        className={cx("block lg:hidden", isBlackFriday && "bg-black grow py-6")}
      >
        {i18n.t(
          isBlackFriday
            ? "banner.blackFridayContentMobile"
            : "banner.contentMobile",
          {},
          { html: true },
        )}
      </div>
    </div>
  );
};
